export enum SearchMode {
	None = 0,
	KeyWord,
	RegEx,
}
